import { Track, TrackLineItem } from "./class/Track";
import { makeAutoObservable } from "mobx";

class Player {
  ingLoadingCount = 0;

  canvasOptions = {
    width: 0,
    height: 0,
  };

  playerConfig = {
    frameCount: 0,
    playerWidth: 1080 / 4,
    playerHeight: 1920 / 4,
  };

  existVideo: false;
  // 当前播放帧
  playStartFrame = 0;
  // 当前播放的元素集合
  playTargetTrackMap = new Map();
  isPause = true;
  constructor() {
    makeAutoObservable(this);
  }

  setPlayStartFrame(v: number) {
    this.playStartFrame = v;
  }

  setPause(v: boolean) {
    this.isPause = v;
  }

  setIngLoadingCount(v: number) {
    this.ingLoadingCount = v;
  }
}

const player = new Player();
export default player;
